import { useCallback } from 'react';
import { Stack } from '@mui/material';
import { NumberInput } from '@common/components/inputs';
import { UserPreferenceName } from '@modules/userPreferences';
import { useUserPreference, useUpdateUserPreferences } from '@/modules/userPreferences/hooks';
import { ResetUserPreferenceButton } from './ResetUserPreferenceButton';

const HISTORY_DEPTH_MIN = 1;
const HISTORY_DEPTH_MAX = 100;

export const HistoryDepthInput = () => {
  const value: number = useUserPreference(UserPreferenceName.APP_HISTORY_DEPTH);
  const { updateUserPreference } = useUpdateUserPreferences();

  const onChange = useCallback(
    (next: number) => {
      if (next >= HISTORY_DEPTH_MIN && next <= HISTORY_DEPTH_MAX) {
        updateUserPreference(UserPreferenceName.APP_HISTORY_DEPTH, next);
      }
    },
    [updateUserPreference],
  );

  return (
    <Stack direction='row' alignItems='center' spacing={0.5}>
      <NumberInput
        sx={{ width: '100%' }}
        value={value}
        onChange={onChange}
        minValue={HISTORY_DEPTH_MIN}
        disabled={false}
      />
      <ResetUserPreferenceButton preference={UserPreferenceName.APP_HISTORY_DEPTH} />
    </Stack>
  );
};
